export function sample<T>(list: T[]): T | void {
  return pick(list, Math.random())
}

export function pick<T>(list: T[], fraction: number): T | void {
  if (fraction < 0 || fraction >= 1) {
    throw new Error("pick called with fraction out of bounds: " + fraction)
  }
  return list[Math.floor(fraction * list.length)]
}

// seededRandom uses the mulberry32 algorithm
export function seededRandom(seed: number) {
  return function () {
    var t = (seed += 0x6d2b79f5)
    t = Math.imul(t ^ (t >>> 15), t | 1)
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61)
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296
  }
}
